import * as React from "react";
import _ from "lodash";

import { ITeamInfo } from "../models/interfaces";

// Team logos live in public/img/teams/{teamId}.svg (see teams.json there for the source).
export const teamLogoUrl = (teamId: number): string => `/img/teams/${teamId}.svg`;

// Inline style that feeds the --team-logo custom property used by the .team-box / .team-logo-cell
// background rules in main.css. Returns an empty style when the team is unknown.
export const teamLogoStyle = (teamId: number | null | undefined): React.CSSProperties => {
    if (_.isNil(teamId) || teamId <= 0) {
        return {};
    }
    return { '--team-logo': `url(${teamLogoUrl(teamId)})` } as React.CSSProperties;
};

// Looks a team up by nickname (e.g. "Rams") or display name; summaries built from the elimination grid only carry names.
export const teamIdForName = (teams: Array<ITeamInfo> | null | undefined, teamName: string | null | undefined): number | null => {
    if (!teams || _.isNil(teamName) || teamName.length === 0) {
        return null;
    }
    const name = teamName.trim().toLowerCase();
    const team = _.find(teams, t =>
        t.name.toLowerCase() === name || t.displayName.toLowerCase() === name || `${t.location} ${t.name}`.toLowerCase() === name);
    return team ? team.teamId : null;
};
